import { SmartTable } from '../../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state, SharedFoldersResource, Alert, ConfirmDeleteModal, ConfirmModal, SharedFolderAddCSAModal, SharedFolderAddNoteModal) {
        this.$state = $state;
        this.SharedFoldersResource = SharedFoldersResource;
        this.Alert = Alert;
        this.ConfirmDeleteModal = ConfirmDeleteModal;
        this.ConfirmModal = ConfirmModal;
        this.SharedFolderAddCSAModal = SharedFolderAddCSAModal;
        this.SharedFolderAddNoteModal = SharedFolderAddNoteModal;
    }

    $onInit() {
        this.st = new SmartTable();
    }

  	rename(newName){
		this.SharedFoldersResource.renameSharedFolder(this.companyId, this.sharedFolder.id, newName)
		.then(()=>{this.$state.reload('company.sharing-center.shared-folders')})
		.then(() => this.Alert('success', 'global.messages.operation-successful'))
		.catch((error) => {});
		
	}

    showDeleteModal(){
        this.isRemoving = true;
        this.ConfirmDeleteModal('company.sharing-center.shared-folders.confirm-delete')
            .then(() => this.SharedFoldersResource.deleteSharedFolder(this.companyId, this.sharedFolder.id))
            .then(() => {
                this.$state.go('^.^', {}, {reload: '^.^'});
                this.Alert('success', 'global.messages.operation-successful');
            })
            .finally(() => this.isRemoving = false)
	}

    addPasswordManager() {
        this.SharedFolderAddCSAModal(false, this.sharedFolder, this.items)
        .then(() => this.$state.reload('company.sharing-center.shared-folders'));
    }

    addAuthenticator() {
        this.SharedFolderAddCSAModal(true, this.sharedFolder, this.items)
        .then(() => this.$state.reload('company.sharing-center.shared-folders'));
    }

    addNote() {
        this.SharedFolderAddNoteModal(this.sharedFolder, this.items)
        .then(() => this.$state.reload('company.sharing-center.shared-folders'));
    }

    removeItems() {
        this.ConfirmModal({
            messageKey: 'company.sharing-center.shared-folders.items.confirm-remove',
            titleKey: 'sp-confirm.title'
        })
        .then(() => {
                this.SharedFoldersResource.removeItems(this.companyId, this.sharedFolder.id, this.st.selectedIds)
                .then(data => {
                    this.$state.reload('company.sharing-center.shared-folders');
                });
            }
        )
        .finally(() => (this.isSending = false));
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-folders/manage/edit/edit-shared-folder.controller.js